import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-tools',
  templateUrl: './icon-tools.component.html',
  styleUrls: ['./icon-tools.component.scss']
})
export class IconToolsComponent implements OnInit {

  @Input() cssClass = 'icon--18';

  constructor() { }

  ngOnInit() {
  }

}
